import { api } from "@/shared/lib/api";

export interface UserTeamLftOption {
  id: string;
  name: string;
  canManageLft?: boolean;
  isTemporary?: boolean;
  archivedAt?: string | null;
}

export async function fetchUserTeamsForLftPost(userId: string): Promise<UserTeamLftOption[]> {
  const res = await api.get<UserTeamLftOption[]>(`/user/${userId}/teams`);
  return Array.isArray(res.data) ? res.data : [];
}
